class CustomBbyActFrom {
    constructor() {
        this.init();
    }

    waitForElement(selector, trigger) {
        var interval = setInterval(function () {
            if (
                document &&
                document.querySelector(selector) &&
                document.querySelectorAll(selector).length > 0
            ) {
                clearInterval(interval);
                trigger();
            }
        }, 50);
        setTimeout(function () {
            clearInterval(interval);
        }, 15000);
    }

    /**
   * Find all occurrences of an element and watch for new elements as they are added to the DOM asynchronously.
   * @param {string} selector - A CSS selector matching the target element(s).
   * @param {Function} callback - The callback that will be fired when an element matching the selector is found.
   * @param {Object} options - Options for observing the selector.
   * @param {number} options.timeout - Timeout duration (not implemented).
   * @param {boolean} options.once - Whether to observe only once.
   * @param {number} options.onTimeout - Timeout callback (not implemented).
   * @param {Document} options.document - Document to observe (default is window.document).
   * @returns {Function} - A "teardown" function that when called will turn off the mutation observer.
   */
    observeSelector(selector, callback, options = {}) {
        const document = options.document || window.document;
        const processed = new Map();

        if (options.timeout || options.onTimeout) {
            throw `observeSelector options \`timeout\` and \`onTimeout\` are not yet implemented.`;
        }

        let obs;
        let isDone = false;

        const done = () => {
            if (obs) obs.disconnect();
            isDone = true;
        };

        const processElement = el => {
            if (!processed.has(el)) {
                processed.set(el, true);
                callback(el);
                if (options.once) {
                    done();
                    return true;
                }
            }
            return false;
        };

        const lookForSelector = elParent => {
            if (elParent.matches(selector) && processElement(elParent)) {
                return true;
            }
            const elements = elParent.querySelectorAll(selector);
            for (const el of elements) {
                if (processElement(el)) return true;
            }
            return false;
        };
        lookForSelector(document.documentElement);

        if (!isDone) {
            obs = new MutationObserver(mutationsList => {
                for (const record of mutationsList) {
                    if (record && record.addedNodes && record.addedNodes.length) {
                        for (const addedNode of record.addedNodes) {
                            const el = addedNode.parentElement;
                            if (el && lookForSelector(el)) return true;
                        }
                    }
                }
            });
            obs.observe(document, {
                attributes: false,
                childList: true,
                subtree: true,
            });
        }

        return done;
    };

    init() {
        var _this = this;

        // Click on ADD to cart Button
        this.observeSelector('button[data-replo-add-product-variant-to-cart]', function (button) {
            button.addEventListener("click", function (evt) {
                if (document.body.classList.contains("bby-4-cart-updates") && _this.isOptionSelected) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    evt.stopImmediatePropagation();
                    _this.onSubmitHandler(evt);
                }
            });
        })

        this.isSizeElementSelected();
    }

    live(selector, event, callback, context) {
        // helper for enabling IE 8 event bindings
        function addEvent(el, type, handler) {
            if (el.attachEvent) el.attachEvent("on" + type, handler);
            else el.addEventListener(type, handler);
        }
        // matches polyfill
        this.Element &&
            (function (ElementPrototype) {
                ElementPrototype.matches =
                    ElementPrototype.matches ||
                    ElementPrototype.matchesSelector ||
                    ElementPrototype.webkitMatchesSelector ||
                    ElementPrototype.msMatchesSelector ||
                    function (selector) {
                        var node = this,
                            nodes = (node.parentNode || node.document).querySelectorAll(selector),
                            i = -1;
                        while (nodes[++i] && nodes[i] != node);
                        return !!nodes[i];
                    };
            })(Element.prototype);
        // live binding helper using matchesSelector
        function live(selector, event, callback, context) {
            addEvent(context || document, event, function (e) {
                var found,
                    el = e.target || e.srcElement;
                while (el && el.matches && el !== context && !(found = el.matches(selector)))
                    el = el.parentElement;
                if (found) callback.call(el, e);
            });
        }
        live(selector, event, callback, context);
    }

    isSizeElementSelected() {
        var _this = this;

        // Click on ADD to cart Button
        this.observeSelector('[data-sf-size-options-section] [data-sf-size-option]', function (option) {
            option.addEventListener("click", function () {
                _this.isOptionSelected = true;
            });

            // Check options size more then 1
            var currentPage = window.location.href;
            var currentPath = window.location.pathname;
            if ((currentPage.includes("/pages/home-v1") || currentPage.includes('/pages/birchbury') || currentPath == '/') && option.classList.length > 1) {
                _this.isOptionSelected = true;
            }

        })
    }

    // Submit Handler
    onSubmitHandler(evt) {
        var cart = document.querySelector("cart-notification");
        var form = evt.target.closest("#Product")?.querySelector("product-form form");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(form);

        // If cart available
        if (cart) {
            formData.append(
                "sections",
                cart.getSectionsToRender().map((section) => section.section)
            );
            formData.append("sections_url", window.location.pathname);
            cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    publish(PUB_SUB_EVENTS.cartError, {
                        source: "product-form",
                        productVariantId: formData.get("id"),
                        errors: response.errors || response.description,
                        message: response.message,
                    });

                    return;
                } else if (!cart) {
                    window.location = window.routes.cart_url;
                    return;
                }

                if (!this.error)
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: "product-form",
                        productVariantId: formData.get("id"),
                    });
                this.error = false;
                const quickAddModal = evt.target.closest("quick-add-modal");
                if (quickAddModal) {
                    document.body.addEventListener(
                        "modalClosed",
                        () => {
                            setTimeout(() => {
                                cart.renderContents(response);
                            });
                        },
                        { once: true }
                    );
                    quickAddModal.hide(true);
                } else {
                    cart.renderContents(response);
                }

                var cartDrawer = document.querySelector("cart-drawer");
                cartDrawer?.classList.remove("is-empty");
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => { });
    }
}
new CustomBbyActFrom();

// Element in viewport
class ElementInViewPort {
    constructor() {
        this.init();
    }

    init() {
        var options = {
            rootMargin: "0px",
            threshold: 0.2,
        };
        var observer = new IntersectionObserver(this.observerCallback, options);
        var target = document.querySelector(".cart__footer .cart__ctas--desktop-control");
        var stickyButton = document.querySelector(".cart__footer .mobile-sticky-button__variant");

        // Target Element
        if (target && stickyButton) {
            observer.observe(target);
        }
    }

    observerCallback(entries) {
        var stickyButton = document.querySelector(".cart__footer .mobile-sticky-button__variant");
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                stickyButton?.classList.remove("sticky-mobile__buttonWrapper");
            } else {
                stickyButton?.classList.add("sticky-mobile__buttonWrapper");
            }
        });
    }
}
new ElementInViewPort();